/**
 * Engine sticky target pick — score-based selection with switch damping.
 * Domain owns the score function (aggro, distance, role bias); this kit only
 * keeps the current target from thrashing every tick.
 */

export type StickyPickKnobs = {
  /** Score bonus granted to the current target (keeps focus). */
  stickyBonus: number;
  /** A challenger must beat current score by at least this much to switch. */
  minSwitchGain: number;
};

export function pickSticky<T>(
  candidates: readonly T[],
  currentId: number,
  idOf: (t: T) => number,
  score: (t: T) => number,
  knobs: StickyPickKnobs,
): T | null {
  let best: T | null = null;
  let bestScore = Number.NEGATIVE_INFINITY;
  let current: T | null = null;
  let currentScore = Number.NEGATIVE_INFINITY;

  for (const c of candidates) {
    const s = score(c);
    if (s <= Number.NEGATIVE_INFINITY) continue;
    if (idOf(c) === currentId) {
      current = c;
      currentScore = s + knobs.stickyBonus;
    }
    if (s > bestScore) {
      best = c;
      bestScore = s;
    }
  }

  if (current) {
    if (best && bestScore >= currentScore + knobs.minSwitchGain) return best;
    return current;
  }
  return best;
}
